module.exports = __webpack_public_path__ + "static/media/22.1b375688.mp3";